export default __webpack_public_path__ + "static/media/about-image.a8383606.jpg";